import api from 'configs/api';
import { IRequestResponse } from 'interfaces/RequestResponse';
import { IGridDataResponse, IGridStockPositionData } from 'interfaces/Grid';
import { IStatusValidityChart, IAmountItemsChart } from 'interfaces/Chart';

const endpointUrl = '/stock';

export const postGridStockPosition = async (queryString, params) => {
  const url = `${endpointUrl}/grid?${queryString}`;
  const { data } = await api.post<
    IRequestResponse<IGridDataResponse<IGridStockPositionData[]>>
  >(url, params);
  return data;
};

export const postChartStatusStock = async params => {
  const url = `${endpointUrl}/chart/status-validity/filter`;
  const { data } = await api.post<IRequestResponse<IStatusValidityChart>>(
    url,
    params,
  );
  return data;
};

export const postChartItemsAmountStock = async params => {
  const url = `${endpointUrl}/chart/items-amount/filter`;
  const { data } = await api.post<IRequestResponse<IAmountItemsChart>>(
    url,
    params,
  );
  return data;
};
